import response from '../../../utils/response'
import interfaceApi from './api'

export default {
  getInterfaceData: {
    state: {
      typographyStyle: ''
    },
    methods: {
      async getType () {
        const api = interfaceApi.getTypography
        const tenantName = window.fe.project === 'supplier-home' ? 'supplier' : window.fe.project
        const req = await response(
          {
            method: api.type,
            url: `/${tenantName}${api.url}`,
            params: {
              key: 'apaas_typography'
            },
            option: {
              authError: false
            }
          }
        )
        if (req.isOk) {
          let reqData = ''
          reqData = req.content === '0' ? 'top' : 'right'
          return reqData
        }
      }
    }
  }
}
